module.exports = __webpack_public_path__ + "static/media/CardholderAgreement.c0eea727.pdf";